var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountTypeCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.42505,
    y: 8.7998,
    width: 4.05,
    height: 4.05,
    fill: "#DCE794"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8625,
    y: 8.7998,
    width: 4.05,
    height: 4.05,
    fill: "#DCE794"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.42505,
    y: 17.9121,
    width: 4.05,
    height: 4.05,
    fill: "#DCE794"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8625,
    y: 17.9121,
    width: 4.05,
    height: 4.05,
    fill: "#DCE794"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3875,
    y: 22.6377,
    width: 4.05,
    height: 4.05,
    fill: "#DCE794"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.7749,
    y: 27.7002,
    width: 9.7875,
    height: 11.8125,
    fill: "#DCE794"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3875,
    y: 31.75,
    width: 4.05,
    height: 4.05,
    fill: "#DCE794"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.751077 0.10986C0.385452 0.1415 0.105957 0.4456 0.105957 0.812985V40.1862C0.105957 40.3725 0.179784 40.5536 0.31338 40.6854C0.445216 40.819 0.624515 40.8928 0.81261 40.8911H40.1876C40.3757 40.8928 40.555 40.819 40.6868 40.6854C40.8204 40.5536 40.8943 40.3725 40.8943 40.1862V18.3454C40.8925 17.957 40.5761 17.6423 40.1876 17.6441H23.3549V3.27062V3.27237C23.3532 2.91554 23.086 2.61672 22.7327 2.57627L0.891918 0.115308C0.844457 0.110034 0.796995 0.108276 0.751293 0.110034L0.751077 0.10986ZM1.51396 1.60049L21.9485 3.89972V39.4866H17.4801V27.4896C17.4783 27.1029 17.1654 26.79 16.7787 26.79H6.68883C6.66598 26.7882 6.64313 26.7882 6.62203 26.79C6.26168 26.8252 5.98744 27.1275 5.98924 27.4896V39.4848H1.51561L1.51396 1.60049ZM5.1456 8.05169H5.14735C4.95927 8.05169 4.77997 8.12551 4.64637 8.25735C4.51453 8.39094 4.44071 8.57024 4.44071 8.75833V13.1072C4.44071 13.2953 4.51453 13.4746 4.64637 13.6064C4.77997 13.74 4.95926 13.8138 5.14735 13.8138H9.6577C9.84579 13.8138 10.0251 13.74 10.1569 13.6064C10.2905 13.4746 10.3644 13.2953 10.3644 13.1072V8.75833C10.3644 8.57025 10.2905 8.39095 10.1569 8.25735C10.0251 8.12551 9.8458 8.05169 9.6577 8.05169H5.1456ZM13.8081 8.05169H13.8099C13.6218 8.05169 13.4425 8.12551 13.3089 8.25735C13.177 8.39094 13.1032 8.57024 13.1032 8.75833V13.1072C13.1032 13.2953 13.177 13.4746 13.3089 13.6064C13.4425 13.74 13.6218 13.8138 13.8099 13.8138H18.3202C18.5083 13.8138 18.6876 13.74 18.8212 13.6064C18.953 13.4746 19.0269 13.2953 19.0269 13.1072V8.75833C19.0269 8.57025 18.953 8.39095 18.8212 8.25735C18.6876 8.12551 18.5083 8.05169 18.3202 8.05169H13.8081ZM5.84715 9.45794H8.95674V12.4058H5.84715V9.45794ZM14.5096 9.45794H17.6192V12.4058H14.5096V9.45794ZM5.0718 16.9743H5.07356C4.71496 17.0112 4.44076 17.3135 4.44076 17.6757V22.0263C4.44076 22.2126 4.51459 22.3936 4.64643 22.5255C4.78002 22.6573 4.95932 22.7311 5.14741 22.7311H9.65776C9.84585 22.7311 10.0251 22.6573 10.157 22.5255C10.2906 22.3936 10.3644 22.2126 10.3644 22.0263V17.6757C10.3627 17.2872 10.0463 16.9725 9.65778 16.9743H5.14743C5.12282 16.9725 5.09997 16.9725 5.07536 16.9743H5.0718ZM13.7343 16.9743H13.7361C13.3775 17.0112 13.1033 17.3135 13.1033 17.6757V22.0263C13.1033 22.2126 13.1771 22.3936 13.3089 22.5255C13.4425 22.6573 13.6218 22.7311 13.8099 22.7311H18.3203C18.5084 22.7311 18.6876 22.6573 18.8213 22.5255C18.9531 22.3936 19.0269 22.2126 19.0269 22.0263V17.6757C19.0252 17.2872 18.7088 16.9725 18.3203 16.9743H13.8099C13.7853 16.9725 13.7625 16.9725 13.7379 16.9743H13.7343ZM5.84535 18.3805H8.95494V21.3231H5.84535V18.3805ZM14.5078 18.3805H17.6174V21.3231H14.5078V18.3805ZM23.3512 19.0503H39.4828V39.4848H23.3548L23.3512 19.0503ZM29.0923 21.9313H29.0959C28.7355 21.9682 28.4613 22.2706 28.4631 22.6327V26.9815C28.4613 27.37 28.7742 27.6864 29.1627 27.6882H33.6784C33.8648 27.6864 34.0441 27.6126 34.1759 27.4807C34.3077 27.3471 34.3816 27.1678 34.3798 26.9815V22.6327C34.3781 22.2459 34.0652 21.933 33.6784 21.9313H29.1627H29.0959L29.0923 21.9313ZM29.8658 23.3376H32.9701V26.2802H29.8658V23.3376ZM7.39236 28.1944H16.0706V39.4849H7.39236V28.1944ZM29.1611 30.8469L29.1629 30.8487C28.7761 30.8504 28.465 31.1633 28.4633 31.5483V35.9042C28.465 36.2909 28.7761 36.602 29.1629 36.6038H33.6786C34.0653 36.6038 34.3782 36.2909 34.38 35.9042V31.5483C34.3782 31.1633 34.0653 30.8504 33.6786 30.8487L29.1611 30.8469ZM29.8677 32.2532H32.972V35.1958H29.8677V32.2532Z",
    fill: "#203D5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountTypeCompany);
export default __webpack_public_path__ + "static/media/account-type-company.9149a33fc48211149cf206a20fb4f923.svg";
export { ForwardRef as ReactComponent };